var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrops(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10647",
    "data-name": "Group 10647",
    transform: "translate(-4 -48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2352",
    "data-name": "Rectangle 2352",
    width: 20,
    height: 20,
    rx: 2,
    transform: "translate(4 48)",
    fill: "#f6f6f6",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10649",
    "data-name": "Group 10649",
    transform: "translate(4.234 48.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25045",
    "data-name": "Path 25045",
    d: "M7.091,7.479,8.533,8.92a4.593,4.593,0,0,0-1.394-.208,4.708,4.708,0,0,0-3.556,1.65.337.337,0,0,0-.016.4,4.348,4.348,0,0,0,3.492,1.714,5.385,5.385,0,0,0,3.556-1.458l2.307,2.307a4.593,4.593,0,0,0-1.394-.208,4.708,4.708,0,0,0-3.556,1.65.337.337,0,0,0-.016.4,4.4,4.4,0,0,0,3.508,1.714,5.385,5.385,0,0,0,3.556-1.458L16.895,17.3a.31.31,0,0,0,.449,0,.31.31,0,0,0,0-.449l-1.858-1.89a5.187,5.187,0,0,0,1.458-3.877,4.265,4.265,0,0,0-1.7-3.172.315.315,0,0,0-.4.016,4.64,4.64,0,0,0-1.65,3.364,4.953,4.953,0,0,0,.208,1.6L11.08,10.57a5.187,5.187,0,0,0,1.458-3.877,4.265,4.265,0,0,0-1.7-3.172.315.315,0,0,0-.4.016A4.64,4.64,0,0,0,8.789,6.9,4.953,4.953,0,0,0,9,8.5L7.539,7.046C7.491,4.147,5.537,2,2.974,2a3.7,3.7,0,0,0-.593.048.3.3,0,0,0-.272.288,4.531,4.531,0,0,0,1.217,3.54A5.14,5.14,0,0,0,7.091,7.479Zm-.016,4.357a3.677,3.677,0,0,1-2.8-1.25A3.937,3.937,0,0,1,7.155,9.353a4.584,4.584,0,0,1,3.028,1.217A4.662,4.662,0,0,1,7.075,11.836Zm4.389,4.405a3.7,3.7,0,0,1-2.8-1.25,3.937,3.937,0,0,1,2.884-1.234,4.584,4.584,0,0,1,3.028,1.217A4.71,4.71,0,0,1,11.464,16.241Zm3.588-7.657a3.645,3.645,0,0,1,1.25,2.547,4.672,4.672,0,0,1-1.25,3.38,4.491,4.491,0,0,1-1.217-3.188A3.915,3.915,0,0,1,15.053,8.584ZM10.663,4.195a3.645,3.645,0,0,1,1.25,2.547,4.672,4.672,0,0,1-1.25,3.38A4.491,4.491,0,0,1,9.446,6.934,3.915,3.915,0,0,1,10.663,4.195ZM2.974,2.641c2.147,0,3.8,1.778,3.925,4.2A4.538,4.538,0,0,1,3.791,5.444,3.989,3.989,0,0,1,2.734,2.657,1.212,1.212,0,0,1,2.974,2.641Z",
    transform: "translate(0 0)",
    fill: "#03bf9e",
    stroke: "#03bf9e",
    strokeWidth: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrops);
export default __webpack_public_path__ + "static/media/crops.7c69de813eb30205794a548ecea1ae83.svg";
export { ForwardRef as ReactComponent };